// api/v1/Search/Document names a hit by the document's folder title, which ends in the extension unless the finder's
// setting envisia.finder.search.api.remove.folder.extension is on. Search/Uploaded names it without the extension
export function finderFileName(name: string, extension: string | null | undefined): string {
  if (!extension || name.toLowerCase().endsWith('.' + extension.toLowerCase())) {
    return name;
  }

  return name + '.' + extension;
}
